export default __webpack_public_path__ + "static/media/d6.943cdb22.jpeg";